const base64toBlob = (data: string) => {
  const bytes = atob(data);
  let length = bytes.length;
  const out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: 'application/pdf' });
};

export const onOpenFile = (url: string, isBase64?: boolean) => {
  if (isBase64) {
    url = URL.createObjectURL(base64toBlob(url));
  }
  window.open(url, '_blank');
};
